import React from 'react';
import { formatMoney, formatNumber } from '../../utils/formatters';

/* Иконки рисуем штрихом вместо эмодзи — см. Navbar.jsx, откуда взят паттерн. */
const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);
const CheckIcon = () => <Icon><circle cx="12" cy="12" r="10" /><path d="M8.5 12.5L10.5 14.5L15.5 9.5" /></Icon>;
const WarningIcon = () => <Icon><path d="M5.31171 10.7615C8.23007 5.58716 9.68925 3 12 3C14.3107 3 15.7699 5.58716 18.6883 10.7615L19.0519 11.4063C21.4771 15.7061 22.6897 17.856 21.5937 19.428C20.4978 21 17.7864 21 12.3637 21H11.6363C6.21356 21 3.50217 21 2.40626 19.428C1.31034 17.856 2.52291 15.7061 4.94805 11.4063L5.31171 10.7615Z" /><path d="M12 8V13" /><path d="M12 16H12.0001" /></Icon>;

const REASONS = {
  cost_over_revenue: 'Себестоимость больше выручки',
  no_cost: 'Нет себестоимости'
};

/* Одна позиция с себестоимостью партии, списанной в продажу поштучно, тянет
   фудкост всей кухни вверх на десятки процентов. Пока такие строки были
   размазаны по общей цифре, объяснить «почему у нас 66%» было невозможно. */
const AnomaliesPanel = ({ foodCost }) => {
  const anomalies = foodCost?.anomalies || [];
  const clean = foodCost?.foodcost_clean || {};

  if (!anomalies.length) {
    return (
      <div className="kt-panel">
        <div className="kt-empty">
          <CheckIcon /> Аномалий не найдено — себестоимость всех позиций выглядит корректно
        </div>
      </div>
    );
  }

  const overrun = anomalies.reduce((sum, item) => sum + Math.max(item.overrun, 0), 0);

  return (
    <>
      <div className="kt-compare-grid">
        <div className="kt-compare-card">
          <div className="kt-compare-label">Фудкост как есть</div>
          <div className="kt-compare-value warn">{foodCost?.total?.foodcost || 0}%</div>
          <div className="kt-compare-note">кухня {foodCost?.kitchen?.foodcost || 0}% • бар {foodCost?.bar?.foodcost || 0}%</div>
        </div>
        <div className="kt-compare-card">
          <div className="kt-compare-label">Фудкост без аномалий</div>
          <div className="kt-compare-value good">{clean.total || 0}%</div>
          <div className="kt-compare-note">кухня {clean.kitchen || 0}% • бар {clean.bar || 0}%</div>
        </div>
        <div className="kt-compare-card">
          <div className="kt-compare-label">Искажение</div>
          <div className="kt-compare-value">
            {Math.round(((foodCost?.total?.foodcost || 0) - (clean.total || 0)) * 10) / 10} п.п.
          </div>
          <div className="kt-compare-note">
            {formatNumber(foodCost?.anomalies_count || 0)} позиций • {formatMoney(overrun)} лишней себестоимости
          </div>
        </div>
      </div>

      <div className="kt-panel">
        <h2><WarningIcon /> Подозрительные позиции</h2>
        <p className="kt-panel-hint">
          Обычно это весовой товар, у которого в продажу списали себестоимость целой партии,
          либо блюдо без техкарты. Пока это не поправят в iiko, ориентируйтесь на фудкост без аномалий.
        </p>
        <div className="kt-table-wrap">
          <table className="kt-table">
            <thead>
              <tr>
                <th>Блюдо</th>
                <th>Группа</th>
                <th className="num">Продано</th>
                <th className="num">Выручка</th>
                <th className="num">Себестоимость</th>
                <th className="num">Фудкост</th>
                <th>Причина</th>
              </tr>
            </thead>
            <tbody>
              {anomalies.map((item, index) => (
                <tr key={`${item.name}-${index}`}>
                  <td className="kt-table-name">{item.name}</td>
                  <td className="kt-dim">{item.group}</td>
                  <td className="num">{formatNumber(item.amount)}</td>
                  <td className="num">{formatMoney(item.revenue)}</td>
                  <td className="num kt-text-danger">{formatMoney(item.cost)}</td>
                  <td className="num kt-text-danger">{item.foodcost}%</td>
                  <td className="kt-dim">{REASONS[item.reason] || item.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AnomaliesPanel;
